import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { courses } from "../utilities/constants";
import { axiosAuth } from "../config/axiosInstances";
import {
  API_GET_LOCATION_WITHOUT_PERMISSION,
  API_KEY_LOCATON_WITH_PERMISSION,
  API_XANO_CERTIFIED_BASE_URL,
} from "../config/api_config";
import { Api_url } from "../common/api_url";
import axios from "axios";

export const fetchTotalRecordsInLeaderboard = createAsyncThunk(
  "fetchTotalRecordsInLeaderboard",
  async ({ certified_user_skill_id }) => {
    try {
      const response = await axiosAuth.get(
        API_XANO_CERTIFIED_BASE_URL + Api_url.LeaderboardTotalRecords,
        {
          params: {
            certified_user_skill_id,
          },
        }
      );
      return response.data?.data;
    } catch (error) {
      console.log(error.message);
    }
  }
);

export const sendUserCareerdetails = createAsyncThunk(
  "sendUserCareerdetails",
  async ({
    certified_user_skill_id,
    current_status,
    career_goal,
    current_job,
    current_degree,
    desired_job,
    selected_skill,
    toggle_info,
  }) => {
    try {
      const response = await axiosAuth.post(
        API_XANO_CERTIFIED_BASE_URL + Api_url.CareerGoals,
        {
          certified_user_skill_id,
          current_status,
          career_goal,
          current_job,
          current_degree,
          desired_job,
          selected_skill,
          toggle_info,
        }
      );
      return response.data.data;
    } catch (error) {
      console.log(error.message);
    }
  }
);

export const sendReferralId = createAsyncThunk(
  "sendReferralId",
  async ({ referral_id, test_bank_id }) => {
    try {
      const response = await axiosAuth.post(
        API_XANO_CERTIFIED_BASE_URL + Api_url.ReferralId,
        {
          referral_id,
          test_bank_id,
        }
      );
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getFirstTransactionDetails = createAsyncThunk(
  "getFirstTransactionDetails",
  async ({ certified_user_skill_id }) => {
    try {
      const response = await axiosAuth.get(
        API_XANO_CERTIFIED_BASE_URL + Api_url.TransactionHistory,
        {
          params: {
            certified_user_skill_id,
          },
        }
      );
      return response.data?.data;
    } catch (error) {
      console.log(error.message);
    }
  }
);

export const additionalQuestionAnswers = createAsyncThunk(
  "additionalQuestionAnswers",
  async ({
    certified_user_skill_id,
    current_focus,
    current_industry_focus,
  }) => {
    try {
      const response = await axiosAuth.post(
        API_XANO_CERTIFIED_BASE_URL + Api_url.AdditionalQuestionAnswer,
        {
          certified_user_skill_id,
          current_focus,
          current_industry_focus,
        }
      );
      return response.data;
    } catch (error) {
      console.log(error.message);
      throw error;
    }
  }
);

export const locationCheck = createAsyncThunk(
  "locationCheck",
  async ({ email }) => {
    try {
      const response = await axiosAuth.get(
        "https://certified-new.learntube.ai/user_loc_data/check",
        { params: {email} }
      );
      if (response?.data?.result === "failed") {
        return false;
      } else {
        return true;
      }
    } catch (error) {
      console.log(error);
    }
  }
);

export const locationWithoutPermission = createAsyncThunk(
  "locationWithoutPermission",
  async ({ email }) => {
    try {

      console.log("email 1", email)
      const location = await axios.get(API_GET_LOCATION_WITHOUT_PERMISSION);
      const city = location.data.city;
      const country = location.data.country_name;
      const state = location.data.state;
      console.log("email 2", email)
      const response = await axiosAuth.post(
        "https://certified-new.learntube.ai/user_loc_data/save",
        {
          email,
          city,
          state,
          country,
          save_type : "temp"
        }
      );
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const locationWithPermission = createAsyncThunk(
  "locationWithPermission",
  async ({ email, latitude, longitude }) => {
    try {
      const locationJSON = await axios.get(
        Api_url.GOOGLE_LOCATION_API +
          "?latlng= " +
          latitude +
          "," +
          longitude +
          `&key=${API_KEY_LOCATON_WITH_PERMISSION}`
      );

      const info = locationJSON.data;
      let location = info.plus_code.compound_code;
      location = location.split(",");

      let array_length = location.length;

      let city = location[array_length - 3];
      let state = location[array_length - 2];
      let country = location[array_length - 1];

      const response = await axiosAuth.post(
        "https://certified-new.learntube.ai/user_loc_data/save",
        {
          email,
          city,
          state,
          country,
          save_type : "accurate"
        }
      );

      return response.data;
    } catch (error) {
      console.log(error);
    }
  }
);


export const referralDetails = createAsyncThunk(
  "referralDetails",
  async ({ email }) => {
    try {
      const response = await axios.get('https://xgfy-czuw-092q.m2.xano.io/api:A_88Z098/landing_page' , {
        params: {
          email
        }
      });

      return response.data.data;
    } catch (error) {
      console.log(error);
    }
  }
);



export const dispatchReferralId = createAsyncThunk(
    'dispatchReferralId',
    async({ referral_id, platform, email, user_id }) => {
        try {
            const response = await axios.post('https://xgfy-czuw-092q.m2.xano.io/api:CjB-KpD3/referral/track', {
                referral_id, platform, email, user_id
            })
            return response.data
        } catch (error) {
            console.log(error.message)
        }
    }
)

// export const uploadResume = createAsyncThunk(
//    'uploadResume',
//    async({ resume }) => {
//     try {
//       const data = new FormData();
//       data.append('certified_user_skill_id', '1219675');
//       data.append('desired_thing', 'analyst');
//       data.append('file', fs.createReadStream('postman-cloud:///1f029709-f06b-4be0-bda2-f84d2a3ff175'));
  
//       const config = {
//         method: 'post',
//         maxBodyLength: Infinity,
//         url: 'https://certified-new.learntube.ai/upload_resume',
//         headers: {
//           ...data.getHeaders()
//         },
//         data: data
//       };
  
//       const response = await axios.request(config);
//       console.log(JSON.stringify(response.data));
//     } catch (error) {
//       console.log(error.message)
//     }
//    }
// )

const initialState = {
  landingPage: {
    skill_name: "",
    course_name: "",
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
  },
  userDetails: {
    user_name: "",
    phone_no: "",
    email: "",
    user_goal: "",
    edited_goal: "",
    professional_experience: "",
    career_goal: "",
    career_degree: "",
    current_job: "",
    skill_to_learn: "",
    referral_id: "",
    test_id: 0,
    userGoalSteps: 0,
    desired_job: "",
    newAdditionalQuestionAnswer: "",
    domainSelected: "",
    otherDomain: "",
    comingFromWhatsAppMessage: false
  },
  certificateList: [],
  noOfcerticatesFromEachCourse: [...Array(courses.length).fill(0)],
  seconds: 0,
  customizedSkillList: [],
  source: "",
  totalRecords: 0,
  relatedJobs: [],
  showAnimation: -1,
  suggestedBundlePurchased: false,
  showProfessionalExperience: false,
  showCareerGoal: false,
  showGoalDetails: false,
  expandCertificate: false,
  certificateDownloaded: false,
  courseLoading: false,
  firstTransactionDetails: {},
  showAddOnsModal: false,
  showCourseModal: false,
  showCategoryModal: false,
  showPlacementModal: false,
  showRelatedSubjectsModal: false,
  showAddOnBundleModal: false,
  currentShareState : 0,
  userCertificateLink : "",
  userCompletedShares : [],
  videoDetails: {
    url: "",
    title: "",
    subtext: "",
    thumbnail: "",
  },
  videoIndex: null,
  showShadow: 0,
  possibleSubjectModal: {
    subjectNumber: "",
    subtitle: "",
  },
  timerSeconds: 15 * 60,
  animationCount: 0,
  showNotificationBar: false,
  showCancellationScreen: false,
  razorpayModalError: '',
  showCartScreen: false,
  showSkillList: false,
  fromAnalysisPage: false,
  referralDetails : {}
};

// Redux slice for questions
const otherDetailsSlice = createSlice({
  name: "otherDetails",
  initialState,
  reducers: {
    setLandingPageDetails: (state, action) => {
      const { skillName, utmSource, courseName, utmMedium, utmCampaign } = action.payload;
      state.landingPage = {
        skill_name: skillName,
        utm_source: utmSource,
        course_name: courseName,
        utm_medium: utmMedium,
        utm_campaign: utmCampaign,
      };
    },
    setUserSkillDetails: (state, action) => {
      state.landingPage.skill_name = action.payload;
    },
    setUserCompletedShares : (state , action) => {
      state.userCompletedShares = action.payload
    },
    setUserName: (state, action) => {
      state.userDetails.user_name = action.payload;
    },
    setUserPhoneNo: (state, action) => {
      state.userDetails.phone_no = action.payload;
    },
    setUserEmail: (state, action) => {
      state.userDetails.email = action.payload;
    },
    setUserCertificateList: (state, action) => {
      state.certificateList = action.payload;
    },
    setUserCertificateLink : (state , action) =>{
      state.userCertificateLink = action.payload
    },
    setUserGoal: (state, action) => {
      const { userGoal } = action.payload;
      state.userDetails.user_goal = userGoal;
    },
    setUserEditedGoal: (state, action) => {
      state.userDetails.edited_goal = action.payload;
    },
    setUserDetails: (state, action) => {
      const { name, email, phone_number } = action.payload;
      state.userDetails.user_name = name;
      state.userDetails.email = email;
      state.userDetails.phone_no = phone_number;
    },
    setSeconds: (state, action) => {
      state.seconds = action.payload;
    },
    setCurrentShareState : (state, action) => {
      state.currentShareState = action.payload
    },
    incrementSeconds: (state) => {
      state.seconds += 1;
    },
    setNoOfcertificatesFromEachCourse: (state, action) => {
      state.noOfcerticatesFromEachCourse = action.payload;
    },
    setCustomizedCertificateList: (state, action) => {
      state.customizedSkillList = action.payload;
    },
    setUserDetailsFromPostPaidFeature: (state, action) => {
      const { name, email, phone_number, subject_name, goal } = action.payload;
      state.userDetails.user_name = name || "";
      state.userDetails.email = email || "";
      state.userDetails.phone_no = phone_number || "";
      state.landingPage.skill_name = subject_name || "";
      state.userDetails.user_goal = goal || "";
    },
    setSource: (state, action) => {
      state.source = action.payload;
    },
    setUserProfessionalExperience: (state, action) => {
      state.userDetails.professional_experience = action.payload;
    },
    setUserCareerGoal: (state, action) => {
      state.userDetails.career_goal = action.payload;
    },
    setUserCareerDegree: (state, action) => {
      state.userDetails.career_degree = action.payload;
    },
    setUserCurrentJob: (state, action) => {
      state.userDetails.current_job = action.payload;
    },
    setUserSkillToLearn: (state, action) => {
      state.userDetails.skill_to_learn = action.payload;
    },
    setUserDesiredJob: (state, action) => {
      state.userDetails.desired_job = action.payload;
    },
    setShowAnimation: (state, action) => {
      state.showAnimation = action.payload;
    },
    setReferralId: (state, action) => {
      state.userDetails.referral_id = action.payload;
    },
    setTestId: (state, action) => {
      state.userDetails.test_id = action.payload;
    },
    setSuggestedBundlePurchased: (state, action) => {
      state.suggestedBundlePurchased = action.payload;
    },
    setUserGoalSteps: (state, action) => {
      state.userDetails.userGoalSteps = action.payload;
    },
    setShowProfessionalExperience: (state, action) => {
      state.showProfessionalExperience = action.payload;
    },
    setShowCareerGoal: (state, action) => {
      state.showCareerGoal = action.payload;
    },
    setShowGoalDetails: (state, action) => {
      state.showGoalDetails = action.payload;
    },
    setExpandCertificate: (state, action) => {
      state.expandCertificate = action.payload;
    },
    setCertificateDownloaded: (state, action) => {
      state.certificateDownloaded = action.payload;
    },
    setCourseLoading: (state, action) => {
      state.courseLoading = action.payload;
    },
    setShowAddOnsModal: (state, action) => {
      state.showAddOnsModal = action.payload;
    },
    setShowCourseModal: (state, action) => {
      state.showCourseModal = action.payload;
    },
    setShowCategoryModal: (state, action) => {
      state.showCategoryModal = action.payload;
    },
    setShowPlacementModal: (state, action) => {
      console.log("i was called", action.payload)
      state.showPlacementModal = action.payload;
    },
    setShowRelatedSubjectsModal: (state, action) => {
      state.showRelatedSubjectsModal = action.payload;
    },
    setVideoDetails: (state, action) => {
      state.videoDetails = action.payload;
    },
    setVideoIndex: (state, action) => {
      state.videoIndex = action.payload;
    },
    setShowAddOnBundleModal: (state, action) => {
      state.showAddOnBundleModal = action.payload;
    },
    setShowShadow: (state, action) => {
      if (action.payload) {
        state.showShadow = action.payload;
      } else {
        state.showShadow += 1;
      }
    },
    setPossibleSubjectModal: (state, action) => {
      state.possibleSubjectModal = action.payload;
    },
    decrementTime: (state) => {
      if (state.timerSeconds > 0) {
        state.timerSeconds -= 1;
      }
    },
    setAnimationCount: (state) => {
      state.animationCount += 1;
    },
    setNotificationBar: (state, action) => {
      state.showNotificationBar = action.payload;
    },
    setShowCancellationScreen: (state, action) => {
      state.showCancellationScreen = action.payload;
    },
    setNewAdditionalQuestionAnswer: (state, action) => {
      state.userDetails.newAdditionalQuestionAnswer = action.payload;
    },
    setOtherDomain: (state, action) => {
      state.userDetails.otherDomain = action.payload;
    },
    setDomainSelected: (state, action) => {
      state.userDetails.domainSelected = action.payload;
    },
    setRazorpayModalError: (state, action) => {
      state.razorpayModalError = action.payload
    },
    setShowCartScreen: (state, action) => {
      state.showCartScreen = action.payload
    },
    setShowSkillList: (state, action) => {
      state.showSkillList = action.payload
    },
    setFromAnalysisPage: (state, action) => {
      state.fromAnalysisPage = action.payload
    },
    setComingFromWhatsAppMessage: (state, action) => {
      state.userDetails.comingFromWhatsAppMessage = action.payload
    },
    resetDetails: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchTotalRecordsInLeaderboard.fulfilled,
      (state, action) => {
        state.totalRecords = action.payload;
      }
    );
    builder.addCase(getFirstTransactionDetails.fulfilled, (state, action) => {
      state.firstTransactionDetails = action.payload;
    });
    builder.addCase(referralDetails.fulfilled , (state , action) => {
      state.referralDetails = action.payload
    });
  },
});

export const {
  setLandingPageDetails,
  setUserSkillDetails,
  setUserName,
  setUserPhoneNo,
  setUserEmail,
  setUserCertificateList,
  setUserGoal,
  setUserEditedGoal,
  setUserDetails,
  setSeconds,
  incrementSeconds,
  setNoOfcertificatesFromEachCourse,
  setCustomizedCertificateList,
  setRequirementForAnalysis,
  setUserDetailsFromPostPaidFeature,
  setSource,
  resetDetails,
  setUserProfessionalExperience,
  setUserCareerGoal,
  setUserCareerDegree,
  setUserCurrentJob,
  setUserSkillToLearn,
  setReferralId,
  setTestId,
  setShowAnimation,
  setSuggestedBundlePurchased,
  setUserGoalSteps,
  setShowProfessionalExperience,
  setShowCareerGoal,
  setShowGoalDetails,
  setExpandCertificate,
  setCertificateDownloaded,
  setCourseLoading,
  setUserDesiredJob,
  setShowAddOnsModal,
  setShowCourseModal,
  setShowCategoryModal,
  setShowPlacementModal,
  setShowRelatedSubjectsModal,
  setVideoDetails,
  setShowAddOnBundleModal,
  setShowShadow,
  setPossibleSubjectModal,
  setVideoIndex,
  decrementTime,
  setAnimationCount,
  setNotificationBar,
  setShowCancellationScreen,
  setNewAdditionalQuestionAnswer,
  setOtherDomain,
  setDomainSelected,
  setRazorpayModalError,
  setShowCartScreen,
  setShowSkillList,
  setFromAnalysisPage,
  setCurrentShareState,
  setUserCertificateLink,
  setUserCompletedShares,
  setComingFromWhatsAppMessage
} = otherDetailsSlice.actions;
export const selectLandingPageDetails = (state) => state.otherDetails.landingPage
export const selectUserDetails = (state) => state.otherDetails.userDetails
export const selectCertificateList = (state) => state.otherDetails.certificateList
export const selectSeconds = (state) => state.otherDetails.seconds
export const selectNoOfCertificatesFromEachCourse = (state) => state.otherDetails.noOfcerticatesFromEachCourse
export const selectCustomizedSkillList = (state) => state.otherDetails.customizedSkillList
export const selectSource = (state) => state.otherDetails.source
export const selectTotalRecords = (state) => state.otherDetails.totalRecords
export const selectShowAnimation = (state) => state.otherDetails.showAnimation
export const selectSuggestedBundleStatus = (state) => state.otherDetails.suggestedBundlePurchased
export const selectShowProfessionalExperience = (state) => state.otherDetails.showProfessionalExperience
export const selectShowCareerGoal = (state) => state.otherDetails.showCareerGoal
export const selectShowGoalDetails = (state) => state.otherDetails.showGoalDetails
export const selectExpandCertificate = (state) => state.otherDetails.expandCertificate
export const selectCertificateDownloaded = (state) => state.otherDetails.certificateDownloaded
export const selectCourseLoading = (state) => state.otherDetails.courseLoading;
export const selectRazorpayModalError = (state) => state.otherDetails.razorpayModalError
export const selectShowCartScreen = (state) => state.otherDetails.showCartScreen
export const selectShowSkillList = (state) => state.otherDetails.showSkillList
export const selectFromAnalysisPage = (state) => state.otherDetails.fromAnalysisPage
export const selectCurrentShareState = (state) => state.otherDetails.currentShareState
export const selectUserCertificateLink = (state) => state.otherDetails.userCertificateLink
export const selectUserCompletedShares = (state) => state.otherDetails.userCompletedShares
export const selectFirstTransactionDetails = (state) =>
  state.otherDetails.firstTransactionDetails;
export const selectShowAddOnsModal = (state) =>
  state.otherDetails.showAddOnsModal;
export const selectShowCourseModal = (state) =>
  state.otherDetails.showCourseModal;
export const selectShowCategoryModal = (state) =>
  state.otherDetails.showCategoryModal;
export const selectShowPlacementModal = (state) =>
  state.otherDetails.showPlacementModal;
export const selectShowRelatedSubjectsModal = (state) =>
  state.otherDetails.showRelatedSubjectsModal;
export const selectVideoDetails = (state) => state.otherDetails.videoDetails;
export const selectShowAddOnBundleModal = (state) =>
  state.otherDetails.showAddOnBundleModal;
export const selectShowShadow = (state) => state.otherDetails.showShadow;
export const selectPossibleSubjectModal = (state) =>
  state.otherDetails.possibleSubjectModal;
export const selectVideoIndex = (state) => state.otherDetails.videoIndex;
export const selectTimerSeconds = (state) => state.otherDetails.timerSeconds;
export const selectAnimationCount = (state) =>
  state.otherDetails.animationCount;
export const selectShowNotificationBar = (state) =>
  state.otherDetails.showNotificationBar;
export const selectShowCancellationScreen = (state) =>
  state.otherDetails.showCancellationScreen;
export const selectReferralDetails = (state) =>
  state.otherDetails.referralDetails

export default otherDetailsSlice.reducer;

